import OwnerOriginList from "containers/owner/OwnerOriginList";
import { Modal } from "react-bootstrap";
import { createElementIdFactory } from "utils/elementIds";

function OwnerOriginModal({
    user,
    filter,
    saveForm,
    data,
    updateTableState,
    saveRecord,
    deleteRecord,
    validateRelatedRecord,
    ownerid,
    countryCodeOptions,
    onClose,
    show,
}) {
    const createId = createElementIdFactory("owner-origin-modal");

    return (
        <Modal id={createId("modal")} show={show} onHide={onClose} size="xl" centered>
            <Modal.Header id={createId("header")} closeButton>
                <Modal.Title>Owner Origin</Modal.Title>
            </Modal.Header>
            <Modal.Body id={createId("body")}>
                <OwnerOriginList
                    filter={filter}
                    isLoading={false}
                    controlType="table"
                    saveForm={saveForm}
                    user={user}
                    data={data}
                    updateTableState={updateTableState}
                    saveRecord={saveRecord}
                    deleteRecord={deleteRecord}
                    validateRelatedRecord={validateRelatedRecord}
                    countryCodeOptions={countryCodeOptions}
                    ownerid={ownerid}
                />
            </Modal.Body>
        </Modal>
    );
}
export default OwnerOriginModal;